module.exports = __webpack_public_path__ + "img/left-arrow.1f17e9c8.svg";